<template>
  <div class="row position-relative align-items-center follow-btn-cta">
    <div class="col-auto text-center">
      <FollowBtn
        :model="account"
        follow-class="btn-accent"
        hover-class="btn-secondary"
        unfollow-class="unfolow-btn"
      />
    </div>
    <div
      class="additional-actions-wrapper col-auto position-absolute d-flex justify-content-end align-items-center"
    >
      <ConversationButton />
      <span
        class="playhera-icon mx-4 cursor-pointer"
        @click.prevent="
          $event =>
            openSharingMenu({
              event: $event,
              type: account._type,
              text: `${$filters.displayName(account)} ${$t(
                '_web_' + account._type,
                account._type
              )} on `,
              id: account._id,
              vanityId: account.vanityId,
            })
        "
      >
        <AppIcon name="share" />
      </span>
      <button
        type="button"
        class="btn-transparent p-2 cursor-pointer text-secondary"
        @click="setActionPopover($event)"
      >
        <AppIcon name="dots" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import actions from '@/mixins/accountActions/profile';
import FollowBtn from '@/components/common/NewFollowBtn';
import AppIcon from '@/components/atoms/Icon';
import ConversationButton from '@/views/account/header/statusBar/default/ConversationButton';
import { sharingMenu } from '@/mixins/sharingMenu';
import AccountModel from '@/models/Account';
import { API } from '@/api/config';

export default {
  name: 'AccountStatusBarActionsProfile',
  components: {
    ConversationButton,
    AppIcon,
    FollowBtn,
  },
  mixins: [...actions, sharingMenu],
  data() {
    return {
      actionPopoverPosition: null,
      blockUserLoading: false,
      isUserBlocked: false,
      model: new AccountModel(),
    };
  },
  computed: {
    ...mapState('current', ['account', 'accountId']),
    ...mapState('my', { myAccount: 'account' }),
  },
  created() {
    this.getIsBlockedAccountInfo();
  },
  methods: {
    ...mapActions({
      openPopoverMenu: 'popoverMenu/open',
    }),
    ...mapActions([
      'getAccountBlockedBy',
      'blockAccount',
      'closeModal',
      'openModal',
      'errorNotify',
    ]),
    async getPostAuthorProfile(id) {
      const response = await API(`/profiles/${id}`);
      this.model = new AccountModel(
        response.data.type,
        response.data.login
      ).update(response.data);
      this.showFollowButton = true;
    },
    openBlockConfirm() {
      return this.openModal({
        name: 'HeraConfirm',
        props: {
          text: this.$t(
            '_web_profile_block_user_request',
            'Are you sure you want to block {name}? All content from this account will be hidden',
            {
              name: this.$filters.displayName(this.account),
            }
          ),
          cancelButtonText: this.$t('_web_post_delete-cancel', 'Cancel'),
          confirmButtonText: this.$t('_web_post_block-confirm', 'Yes, block'),
          isLoading: this.blockUserLoading,
        },
        events: {
          cancel: this.closeModal,
          confirm: this.blockAccountAction,
        },
        options: {
          clickOnBackdrop: false,
          escKey: false,
        },
      });
    },
    blockAccountAction() {
      this.blockUserLoading = true;
      this.blockAccount({
        accountType: this.account._type,
        accountId: this.accountId,
      })
        .then(() => {
          this.closeModal();
          this.isUserBlocked = true;
          this.$emit('authorBlocked');
        })
        .catch(this.errorNotify)
        .finally(() => {
          this.blockUserLoading = false;
        });
    },
    getIsBlockedAccountInfo() {
      this.isLoading = true;
      this.getAccountBlockedBy({
        accountType: this.account._type,
        accountId: this.accountId,
      })
        .then(res => {
          res.map(profile => {
            if (profile === this.myAccount.login) this.isUserBlocked = true;
          });
        })
        .catch(this.errorNotify)
        .finally(() => {
          this.isLoading = false;
        });
    },
    setActionPopover(event) {
      const items = [
        {
          label: this.isUserBlocked
            ? this.$t('_web_user-is-blocked', '{name} is blocked', {
                name: this.$filters.displayName(this.account),
              })
            : this.$t('_web_post_block-user', 'Block {name}', {
                name: this.$filters.displayName(this.account),
              }),
          action: this.isUserBlocked ? null : this.openBlockConfirm,
          loading: this.blockUserLoading,
        },
        /* Commented by TH-7921
              {
                label: this.reportProfileText(),
                action: () => this.reportProfileAction(),
                loading: this.waitingReportRequest,
              }, */
      ];
      if (this.myAccount.isProfile) {
        items.push({
          label: this.friendRequestProfileText(this),
          action: () => this.friendRequestProfileAction(this),
          loading: this.waitingFriendRequest,
        });
        if (this.account.socialMetadata.is_friend_requested_by) {
          items.push({
            label: this.friendRequestProfileText({
              account: this.account,
              isDeclineRequest: true,
            }),
            action: () =>
              this.friendRequestProfileAction({
                account: this.account,
                isDeclineRequest: true,
              }),
          });
        }
      }

      this.openPopoverMenu({
        event,
        settings: {
          stopItemClickBubbling: true,
          isFixed: false,
          autoClose: true,
          targetSelector: 'svg',
        },
        items,
      });
    },
  },
};
</script>

<style lang="scss">
.follow-btn-cta {
  justify-content: center;
}
.additional-actions-wrapper {
  @include auto-rtl(right, 0);
}
@media screen and (max-width: 767px) {
  .follow-btn-cta {
    justify-content: start;
  }
}
</style>
